import {
  GETALL_TIPOS_CONTACTOS,
  LOADING_GETALL_TIPOS_CONTACTOS,
  ACTIVO_TIPOS_CONTACTOS,
  SET_LOGOUT,
  CLEAR_ALL,
  PARAMS_TIPOS_CONTACTOS,
} from '../../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const tiposContactosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_CONTACTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TIPOS_CONTACTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_CONTACTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_CONTACTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
